import sc from 'styled-components';
import {Dialog} from '@phonectas/unifon-ui-kit';


export interface StyledDialogProps {
    $width?: number;
    $noOverflow?: boolean;
    // $maxHeight?: number;
    $noPadding?: boolean;
    open?: boolean;
    $noPaddingHeader?: boolean;
}

export const StyledMrcDialog = sc(Dialog)<StyledDialogProps>`
    width: ${({$width}) => typeof $width === 'number' ? `${$width}px` : '690px'};
    flex-wrap: nowrap;
    padding:  ${({$noPadding}) => $noPadding ? '0' : '16px'};
    overflow: ${({$noOverflow}) => $noOverflow ? 'hidden' : 'auto'};
    box-sizing: border-box;
`;
// max-height: ${({$maxHeight}) => typeof $maxHeight === 'number' ? `${$maxHeight}vh` : '80vh'};